import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import { QUERY_WIDTHS } from "@utils/index";
import BgImg from "@assets/images/layout-bg.png";
import LogoImg from "@assets/images/logo.svg";
import AwardImg from "@assets/images/award.png";

export const RightSidebarNotAuth = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery({ query: QUERY_WIDTHS.md });

  return (
    <div
      className="w-[880px] bg-top bg-no-repeat md:!bg-none xxl:w-full"
      style={{ backgroundImage: `url('${BgImg}')` }}
    >
      <div className="bg-gradient-to-b from-[#283583B2] to-[#0B83CBB2] md:h-full md:bg-none">
        {isMobile && (
          <div className="relative h-[137px] px-4 pt-16">
            <img
              src={AwardImg}
              alt="Award"
              width="80"
              height="80"
              className="absolute right-6 top-24"
            />
            <Link to="/">
              <img
                src={LogoImg}
                alt="Logo"
                width={200}
                className="relative -left-6 -top-6"
              />
            </Link>
          </div>
        )}
        <div className="flex min-h-[calc(100dvh_-_137px)] w-dvw flex-col justify-between rounded-t-2xl bg-white-100 px-4 py-8 md:h-full md:min-h-dvh md:w-full md:rounded-e-lg md:rounded-ss-none md:p-6">
          {children}
        </div>
      </div>
    </div>
  );
};
